import React from 'react';
import Modal from 'react-modal';
import styled from "styled-components";
import PhotoCaption from "./photoCaption";
import { useMyContext } from '@/app/utils/MyContext';
import { useBodyScrollLock } from "@/app/utils/Common";
export const generateSingleImgData = (src: string, capTitle?: string, capContent?: string) => ({
  captionTitle: {value: capTitle},
  captionContent: {value: capContent},
  singlePhoto: {src: src},
})
 
const CloseButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 24px 12px 0px 12px;
  gap: 10px;

  width: 100%;
  height: 48px;
  background-color:black;

  img
  {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
`;

const PhotoDiv = styled.div`
  height: 700px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #333333;
  border-radius: 4px;
  overflow: hidden;

  img
  {
    height: initial;
    width: initial;
    max-width: 100%;
    max-height: 100%;
  }
`;
const PhotoDivMobile = styled.div`
  height: calc(100% - 48px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  width: 100%;
  border-radius: 0px;
  background-color:black;

  img
  {
    height: initial;
    width: initial;
    max-width: 100%;
    max-height: 100%;
    border-radius: 0px;
  }
`;

const customStyles = {
  overlay:{
      zIndex: "999"
  },
  content: {
    width: "100%",
    height: "100%",
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    marginRight: '0',
    padding: '0',
    zIndex: "999"
  },
};

const SinglePhoto: React.FC<any> = (props: any) => {
  const {state:myContextState} = useMyContext();
  const {data, type, disableCaption, isOpen, onRequestClose} = props;
  console.log("SinglePhotoData",data);
  const title = data?.captionTitle?.value;
  const content = data?.captionContent?.value;
  const photoUrl = data?.singlePhoto?.src;
  //const photoUrl = "/raceInfo.png";
  useBodyScrollLock(isOpen);
  return (
    type==="pc" ? <PhotoDiv>
        <img src={photoUrl}></img>
        <PhotoCaption title={title} content={content} isDesktop={type==="pc"} index={0}></PhotoCaption>
      </PhotoDiv> :
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        style={customStyles}
        ariaHideApp={false}
        contentLabel="">
        <CloseButtonDiv>
          <img onClick={onRequestClose} src={`${myContextState.assetPrefix}/commonImg/close.svg`}></img>
        </CloseButtonDiv>
        <PhotoDivMobile>
          <img src={photoUrl}></img>
          {!disableCaption && <PhotoCaption title={title} content={content} isDesktop={type==="pc"} index={0}></PhotoCaption>}
        </PhotoDivMobile>
      </Modal>
  );
};
 
export default SinglePhoto